// ─── Les erreurs du rattachement, en français — module PUR ────────
// « rattachement.montantNul » s'affichait TEL QUEL dans l'alerte (Cédric,
// 15/08) : un code interne présenté comme une phrase. Chaque motif a
// désormais sa clé i18n ; un motif inconnu retombe sur le message brut —
// mieux vaut un code lisible qu'un silence.
export function cleErreur(e) {
  const m = String(e?.message || '');
  if (!m.startsWith('rattachement.')) return null;
  return `finances.err_${m.slice('rattachement.'.length)}`;
}
